import React from 'react';
// @ts-ignore
import styles from './ManagerWorkplaceCreateOptionsList.module.scss';
import ManagerWorkplaceCreateOptionsListItem, {
	DynamicWorkplaceItem,
} from './ManagerWorkplaceCreateOptionsListItem';
import { WorkplaceType } from '../../../Enums/WorkplaceType.enum';
import useWorkplaceManager from '../../../Hooks/useWorkplaceManager';
import Loading from '../../../../../Components/Loading';

interface Props {
	onSuccess: () => void;
}

const ManagerWorkplaceCreateOptionsList: React.FC<Props> = ({ onSuccess }) => {
	const { workplaceNormalFormScheme, workplaceFolderFormScheme, isLoading } =
		useWorkplaceManager();

	//STATIC OPTIONS LIST IN APP, CAN BE LOADED FROM API IN FUTURE
	const STATIC_DATA: DynamicWorkplaceItem[] = [
		{
			type: WorkplaceType.NORMAL,
			label: 'component.managerWorkplaceCreateOptionsList.workplace',
			formScheme: workplaceNormalFormScheme,
		},
		{
			type: WorkplaceType.FOLDER,
			label: 'component.managerWorkplaceCreateOptionsList.folder',
			formScheme: workplaceFolderFormScheme,
		},
	];

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{STATIC_DATA.map((item, key) => (
				<ManagerWorkplaceCreateOptionsListItem
					item={item}
					key={key}
					onSuccess={onSuccess}
				/>
			))}
		</div>
	);
};

export default ManagerWorkplaceCreateOptionsList;
